import angular from "angular";
import dcFlash from "./flash.directive";
import dcFlashController from "./flash.controller";
export default angular
  .module("directives.flash", [])
  .directive("dcFlash", dcFlash)
  .controller("dcFlashController", dcFlashController);
